// src/hooks/useDocumentTitle.js
import { useEffect } from 'react';

const SITE_NAME = 'Arian Kazemi';

export default function useDocumentTitle(title, description) {
  useEffect(() => {
    document.title = title ? `${title} · ${SITE_NAME}` : SITE_NAME;

    if (description) {
      const meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute('content', description);
    }
  }, [title, description]);
}
